import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "value", "type", "onChange", "onValueChange", "disabled", "inputRef", "onClear", "onKeyDown", "onPressEnter", "onCompositionStart", "onCompositionUpdate", "onCompositionEnd"],
    _excluded2 = ["onClearClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file withInputWrapper
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import React from 'react';
import { INPUT_COMMON_ATTRS } from '../const/input';
import { useCompositionInput } from '../hooks/useCompositionInput';
export function withInputWrapper(Component) {
  return function (props) {
    var children = props.children,
        value = props.value,
        type = props.type,
        onChange = props.onChange,
        onValueChange = props.onValueChange,
        disabled = props.disabled,
        inputRef = props.inputRef,
        onClear = props.onClear,
        onKeyDown = props.onKeyDown,
        onPressEnter = props.onPressEnter,
        onCompositionStart = props.onCompositionStart,
        onCompositionUpdate = props.onCompositionUpdate,
        onCompositionEnd = props.onCompositionEnd,
        extra = _objectWithoutProperties(props, _excluded);

    var _useCompositionInput = useCompositionInput({
      value: value,
      onChange: onChange,
      onValueChange: onValueChange,
      inputRef: inputRef,
      onClear: onClear,
      onKeyDown: onKeyDown,
      onPressEnter: onPressEnter,
      onCompositionStart: onCompositionStart,
      onCompositionUpdate: onCompositionUpdate,
      onCompositionEnd: onCompositionEnd
    }),
        onClearClick = _useCompositionInput.onClearClick,
        composition = _objectWithoutProperties(_useCompositionInput, _excluded2);

    var input = {};
    INPUT_COMMON_ATTRS.forEach(function (key) {
      if (key in extra) {
        Object.assign(input, _defineProperty({}, key, extra[key]));
        delete extra[key];
      }
    });
    return React.createElement(Component, _objectSpread(_objectSpread({}, extra), {}, {
      disabled: disabled,
      onClear: onClearClick
    }), React.createElement("input", _objectSpread(_objectSpread({
      type: type,
      disabled: disabled
    }, composition), input)), children);
  };
}